import NextLink from "next/link";
import { Center } from "@chakra-ui/react";
import PrivcoLogoSolid from "components/icons/privco-logo-solid";

const AppHeaderLogo = () => (
  <Center
    aria-label="PrivCo Home"
    as={NextLink}
    href="/"
    h={10}
    w={10}
    outline="none"
    rounded="md"
    transition="0.2s all"
    flex="0 0 auto"
    _hover={{
      bg: "blackAlpha.300",
    }}
    _active={{
      bg: "blackAlpha.400",
    }}
    _focus={{
      boxShadow: "outline-light",
    }}
  >
    <PrivcoLogoSolid h={8} w={8} />
  </Center>
);

export default AppHeaderLogo;
